import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouteSlug } from '@app/_models';

@Component({
  selector: 'app-auth-footer',
  styleUrls: ['./auth-footer.component.scss'],
  imports: [NgOptimizedImage],
  template: `
    <footer class="app-auth-footer">
      <div class="app-auth-footer__bot">
        <div class="container app-auth-footer__bot__con">
          <img
            class="app-auth-footer__bot__con__img"
            ngSrc="assets/images/business-logo.svg"
            alt="logo"
            width="148"
            height="69"
          />
        </div>
      </div>
    </footer>
  `,
})
export class AuthFooterComponent {
  protected readonly RouteSlug = RouteSlug;
}
